import me from "./me.png";
import prof from "./prof.png";
import project from "./project.png";
import ab from "./ab.jpg";
import capstone from "./capstone.png";
import todo from "./todo.png";
import sav from "./sav.png";
import group from "./Group 14.png";
import billTracker from "./billTracker.png";

const Images = {
  me,
  prof,
  project,
  ab,
  capstone,
  todo,
  sav,
  group,
  billTracker,
};

export default Images;
